import { render, staticRenderFns } from "./rulesSetting.vue?vue&type=template&id=4bf4b8a1&scoped=true&"
import script from "./rulesSetting.vue?vue&type=script&lang=js&"
export * from "./rulesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4b8a1",
  null
  
)

export default component.exports